<form [formGroup]="dataForm" class="without-default-focus">
    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Configuration d'API</mat-label>
            <mat-select data-select-configurationApiId formControlName="configurationApiId" required tabindex="10">
                @for (item of _apiConfigurations; track item) {
                    <mat-option data-select-listing-type-option [value]="item.id">
                        {{ item.name }}
                    </mat-option>
                }
            </mat-select>
            @if (
                dataForm.errors &&
                dataForm.errors['configurationApiId']?.required &&
                (dataForm.controls['configurationApiId']?.dirty || dataForm.controls['configurationApiId'].touched)
            ) {
                <mat-error data-input-role-error>Le champ 'Configuration d'API' est obligatoire</mat-error>
            }
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Configuration d'API" matTooltipPosition="right"></fa-icon>
    </div>
</form>
